import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
    selector: 'app-mapa-tempo',
    templateUrl: './mapa-tempo.component.html',
    styleUrls: ['./mapa-tempo.component.css'],
})
export class MapaTempoComponent {
    }
